import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../shared/AuthContext';
import rolePermissions from '../../../shared/rolePermissions';

const Components = {};




Components[ 'children' ] = {
  meta: {},
  label: 'Children',
  fields: [
    {
      handle: 'slug',
      label: 'Slug',
      field: {
        meta: {
        },
        value: 'model'
      }
    },
    {
      handle: 'parentId',
      label: 'Parent Id',
      field: {
        meta: {
        },
        value: 'text'
      }
    },
    {
      handle: 'title',
      label: 'Title',
      field: {
        meta: {
        },
        value: 'text'
      }
    },
    {
      handle: 'details',
      label: 'Details',
      field: {
        meta: {
        },
        value: 'raw'
      }
    },
  ],

  loadDomain: async ({ handle, meta, parentId, result }) => {

    const Factory = require( '../../../records/modules' ).default;

    const filters = {};
    filters[ meta.parentId ] = parentId;

    const response = await Factory( {
      slug: meta.slug
    } ).Data.getRecords( {
      limit: 100,
      page: 1,
      sort: 'updatedAt',
      order: 'DESC',
      ...filters
    } );

    result[ handle ] = response.data.map( ( row ) => ({
      data: row 
    }));


    result[`${handle}Model`] = await Factory( {
      slug: 'models'
    } ).Meta.getRecord( meta.slug );
  },

  Input: ({ handle, meta, domain, parentId, updateDomain }) => {

  },

  Output: ({ handle, meta, domain, parentId }) => {

    const Model = domain[`${handle}Model`] || {
      handle: {
        label: 'Record',
        handle: 'id',
        field: {
          meta: {},
          value: 'text'
        }
      },
      fields: [],
    };

    const RecordSection = require( '../../../components/view/RecordSection' ).default;
    const RecordList = require( '../../../components/view/RecordList' ).default;

    const { user } = useAuth();
    const canCreate = rolePermissions.hasPermission(user, 'content.create');

    return (
      <RecordSection
        title={meta.title}
        className="record-related"
        actions={(parentId && canCreate ? (
          <Link className="button-primary" to={`/${meta.slug}/new?${meta.parentId}=${parentId}`} >
            New {Model.handle.label}
          </Link>
        ) : null)}
      >
        
        <RecordList
          slug={meta.slug}
          single={Model.handle.label}
          order={null}
          sort={''}
          updateParams={() => {}}
          DEFAULT_ASC_FIELDS={[]}
          data={{
            rows: domain[ handle ] || [],
            handle: {
              column: {
                label: Model.handle.label,
                field: Model.handle.handle,
              },
              row: {
                meta: Model.handle.field.meta,
                value: Model.handle.field.value
              }
            },
            details: (() => {

              const fields = [];
              
              fields.push( {
                column: {
                  label: 'Status',
                  field: 'status',
                },
                row: {
                  meta: {},
                  value: 'status'
                }
              } );
              
              meta.details.map( ( detail ) => {
                return Model.fields.find( ( item ) => item.handle === detail );
              } ).forEach( ( field ) => {
                if ( field ) fields.push( {
                  column: {
                    label: field.label,
                    field: field.handle,
                  },
                  row: {
                    meta: field.field.meta,
                    value: field.field.value
                  }
                } );
              } );

              return fields;
            })()
            
          }}
        />

        <div className="row-between">
          <span className="table-record-count">{domain[ handle ]?.length} records</span>
          <div className="pagination-controls">
            {/* todo */}
          </div>
        </div>

      </RecordSection>
    );
  },

  validate: async ({ handle, meta, parentId, domain }) => {

  }
};




Components[ 'successFactors' ] = {
  meta: {},
  label: 'Success Factors',
  fields: [
    {
      handle: 'slug',
      label: 'Slug',
      field: {
        meta: {
        },
        value: 'model'
      }
    },
    {
      handle: 'parentId',
      label: 'Parent Id',
      field: {
        meta: {
        },
        value: 'text'
      }
    },
  ],

  loadDomain: async ({ handle, meta, parentId, result }) => {

    const Factory = require( '../../../records/modules' ).default;

    const filters = {};
    filters[ meta.parentId ] = parentId;

    const response = await Factory( {
      slug: meta.slug
    } ).Data.getRecords( {
      limit: 100,
      page: 1,
      sort: 'updatedAt',
      order: 'DESC',
      ...filters
    } );

    result[ handle ] = response.data.map( ( row ) => ({
      data: row 
    }));
  },

  Input: ({ handle, meta, domain, parentId, updateDomain }) => {

    const SuccessFactors = require( '../../../components/form/SuccessFactors' ).default;

    return <SuccessFactors
      handle={handle} 
      meta={meta} 
      domain={domain} 
      parentId={parentId}
      updateDomain={updateDomain}
    />;
  },

  Output: ({ handle, meta, domain, parentId }) => {

    const SuccessFactors = require( '../../../components/view/SuccessFactors' ).default;

    return <SuccessFactors
      handle={handle} 
      meta={meta} 
      domain={domain}
      parentId={parentId}
    />;
  },

  validate: async ({ handle, meta, parentId, domain }) => {

    const Factory = require( '../../../records/modules' ).default;
    
    const enteredFactors = domain.successFactors
      .filter((item) => item.name.trim())
      .map((item) => ({
        ...item,
        name: item.name.trim(),
        targetValue: item.targetValue === '' ? null : Number(item.targetValue),
        currentValue: item.currentValue === '' ? null : Number(item.currentValue),
      }));

    const retainedIds = enteredFactors.filter((item) => item.id).map((item) => item.id);
    const deletedIds = domain.initialFactorIds.filter((factorId) => !retainedIds.includes(factorId));

    await Promise.all(
      enteredFactors.map( (factor) => {
        const factorPayload = {
          name: factor.name,
          status: factor.status,
          targetValue: factor.targetValue,
          currentValue: factor.currentValue,
        };
        return factor.id
          ? Factory( { slug: meta.slug } ).Data.updateRecord(factor.id, factorPayload)
          : Factory( { slug: meta.slug } ).Data.createRecord({
              ...factorPayload,
              [meta.parentId]: parentId,
            });
      })
    );

    await Promise.all(
      deletedIds.map((factorId) => Factory( { slug: meta.slug } ).Data.deleteRecord(factorId))
    );
  }
};




Components[ 'weeklyUpdates' ] = {
  meta: {},
  label: 'Weekly Updates',
  fields: [
    {
      handle: 'slug',
      label: 'Slug',
      field: {
        meta: {
        },
        value: 'model'
      }
    },
    {
      handle: 'parentId',
      label: 'Parent Id',
      field: {
        meta: {
        },
        value: 'text'
      }
    },
  ],

  loadDomain: async ({ handle, meta, parentId, result }) => {

    const Factory = require( '../../../records/modules' ).default;

    const filters = {};
    filters[ meta.parentId ] = parentId;

    const response = await Factory( {
      slug: meta.slug
    } ).Data.getRecords( {
      limit: 100,
      page: 1,
      sort: 'updatedAt',
      order: 'DESC',
      ...filters
    } );

    result[ handle ] = response.data.map( ( row ) => ({
      data: row 
    }));
  },

  Input: ({ handle, meta, domain, parentId, updateDomain }) => {

    const WeeklyUpdates = require( '../../../components/form/WeeklyUpdates' ).default;

    return <WeeklyUpdates 
      handle={handle} 
      meta={meta} 
      domain={domain}
      parentId={parentId}
      updateDomain={updateDomain}
    />;
  },

  Output: ({ handle, meta, domain, parentId }) => {

    const WeeklyUpdates = require( '../../../components/view/WeeklyUpdates' ).default;

    return <WeeklyUpdates 
      handle={handle} 
      meta={meta} 
      domain={domain}
      parentId={parentId}
    />;
  },

  validate: async ({ handle, meta, parentId, domain }) => {
    const Factory = require( '../../../records/modules' ).default;
    
    const enteredWeekly = (domain.weeklyUpdates || []).filter((item) => item.weekStart && item.summary.trim());

    const retainedWeeklyIds = enteredWeekly.filter((item) => item.id).map((item) => item.id);
    
    await Promise.all(
      enteredWeekly.map((item) => {
        const payload = {
          weekStart: item.weekStart,
          summary: item.summary.trim(),
          health: item.health,
          blockers: item.blockers.trim() || null,
          nextSteps: item.nextSteps.trim() || null,
        };
        return item.id
          ? Factory( { slug: meta.slug } ).Data.updateRecord(item.id, payload)
          : Factory( { slug: meta.slug } ).Data.createRecord({
              ...payload,
              [meta.parentId]: parentId,
            });
      })
    );

    await Promise.all(
      (domain.initialWeeklyIds || [])
        .filter((rowId) => !retainedWeeklyIds.includes(rowId))
        .map((rowId) => Factory( { slug: meta.slug } ).Data.deleteRecord(rowId))
    );
  }
};




Components[ 'tasks' ] = {
  meta: {},
  label: 'Tasks',
  fields: [
    {
      handle: 'slug',
      label: 'Slug',
      field: {
        meta: {
        },
        value: 'model'
      }
    },
    {
      handle: 'parentId',
      label: 'Parent Id',
      field: {
        meta: {
        },
        value: 'text'
      }
    },
  ],

  loadDomain: async ({ handle, meta, parentId, result }) => {

    const Factory = require( '../../../records/modules' ).default;

    const filters = {};
    filters[ meta.parentId ] = parentId;

    const response = await Factory( {
      slug: meta.slug
    } ).Data.getRecords( {
      limit: 100,
      page: 1,
      sort: 'updatedAt',
      order: 'DESC',
      ...filters
    } );

    result[ handle ] = response.data.map( ( row ) => ({
      data: row 
    }));
  },

  Input: ({ handle, meta, domain, parentId, updateDomain }) => {

    const Tasks = require( '../../../components/form/Tasks' ).default;

    return <Tasks 
      handle={handle} 
      meta={meta} 
      domain={domain}
      parentId={parentId}
      updateDomain={updateDomain}
    />;
  },

  Output: ({ handle, meta, domain, parentId }) => {

    const Tasks = require( '../../../components/view/Tasks' ).default;

    return <Tasks 
      handle={handle} 
      meta={meta} 
      domain={domain}
      parentId={parentId}
    />;
  },

  validate: async ({ handle, meta, parentId, domain }) => {

    const Factory = require( '../../../records/modules' ).default;
    
    const enteredTasks = (domain.tasks || []).filter((item) => item.title.trim());

    const retainedTaskIds = enteredTasks.filter((item) => item.id).map((item) => item.id);

    await Promise.all(
      enteredTasks.map((item) => {
        const payload = {
          title: item.title.trim(),
          status: item.status,
          dueDate: item.dueDate || null,
          sortOrder: Number(item.sortOrder || 0),
        };
        return item.id
          ? Factory( { slug: meta.slug } ).Data.updateRecord(item.id, payload)
          : Factory( { slug: meta.slug } ).Data.createRecord({
              ...payload,
              [meta.parentId]: parentId,
            });
      })
    );

    await Promise.all(
      (domain.initialTaskIds || [])
        .filter((rowId) => !retainedTaskIds.includes(rowId))
        .map((rowId) => Factory( { slug: meta.slug } ).Data.deleteRecord(rowId))
    );
  }
};




Components[ 'metrics' ] = {
  meta: {},
  label: 'Metrics',
  fields: [
    {
      handle: 'slug',
      label: 'Slug',
      field: {
        meta: {
        },
        value: 'model'
      }
    },
    {
      handle: 'parentId',
      label: 'Parent Id',
      field: {
        meta: {
        },
        value: 'text'
      }
    },
  ],

  loadDomain: async ({ handle, meta, parentId, result }) => {

    const Factory = require( '../../../records/modules' ).default;

    const filters = {};
    filters[ meta.parentId ] = parentId;

    const response = await Factory( {
      slug: meta.slug
    } ).Data.getRecords( {
      limit: 100,
      page: 1,
      sort: 'updatedAt',
      order: 'DESC',
      ...filters
    } );

    result[ handle ] = response.data.map( ( row ) => ({
      data: row 
    }));
  },

  Input: ({ handle, meta, domain, parentId, updateDomain }) => {

    const Metrics = require( '../../../components/form/Metrics' ).default;

    return <Metrics 
      handle={handle} 
      meta={meta} 
      domain={domain}
      parentId={parentId}
      updateDomain={updateDomain}
    />;
  },

  Output: ({ handle, meta, domain, parentId }) => {

    const Metrics = require( '../../../components/view/Metrics' ).default;

    return <Metrics 
      handle={handle} 
      meta={meta} 
      domain={domain}
      parentId={parentId}
    />;
  },

  validate: async ({ handle, meta, parentId, domain }) => {
    const Factory = require( '../../../records/modules' ).default;

    const metricKeyFromLabel = (label) => {
      return label
        .toLowerCase()
        .trim()
        .replace(/[^\w\s-]/g, '')
        .replace(/\s+/g, '_');
    };
          
    const enteredMetrics = (domain.metrics || []).filter((item) => item.metricLabel.trim() && item.value !== '');

    const retainedMetricIds = enteredMetrics.filter((item) => item.id).map((item) => item.id);

    await Promise.all(
      enteredMetrics.map((item) => {
        const payload = {
          status: item.status || 'active',
          metricLabel: item.metricLabel.trim(),
          metricKey: item.metricKey.trim() || metricKeyFromLabel(item.metricLabel),
          value: Number(item.value),
          targetValue: item.targetValue === '' ? null : Number(item.targetValue),
          unit: item.unit.trim() || null,
          recordedOn: item.recordedOn || null,
          trend: item.trend,
          note: item.note.trim() || null,
        };
        return item.id
          ? Factory( { slug: meta.slug } ).Data.updateRecord(item.id, payload)
          : Factory( { slug: meta.slug } ).Data.createRecord({
              ...payload,
              [meta.parentId]: parentId,
            });
      })
    );

    await Promise.all(
      (domain.initialMetricIds || [])
        .filter((rowId) => !retainedMetricIds.includes(rowId))
        .map((rowId) => Factory( { slug: meta.slug } ).Data.deleteRecord(rowId))
    );
  }
};

// Typed edges are managed by RecordLinksSection; the domain entry only keeps record pages from crashing.
Components[ 'links' ] = {
  meta: {},
  label: 'Links',
  fields: [],
  loadDomain: async () => null,
  Input: () => null,
  Output: () => null,
  validate: async () => {},
};

export default Components;
